import * as utils from '../data/utils.js';

// --------------------------------------------------------------------------------------------

function parseQueryString(uri, x, y) {

    uri = (uri && uri[0]) == '?' ? uri.slice(1) : uri;
    x = x || function (x) {
        x = decodeURIComponent(x && x.replace(/\+/g, ' '));
        return (!isNaN(parseInt(x)) && !isNaN(x * 1)) ? x * 1 : x;
    };
    y = y || decodeURIComponent;

    var o = {};

    if (uri === '') {
        return o;
    }

    function add(target, key, value) {
        if (target.hasOwnProperty(key)) {
            if (target[key] instanceof Array) {
                target[key].push(value);
            } else if (!(target[key] instanceof Object)) {
                target[key] = [target[key], value];
            }
        } else {
            target[key] = value;
        }
        target = target[key];
        return target;
    }

    return uri.match(/([^=&]+)(=([^&]*))?/g).reduce(function (c, p, i, d) {
        i = /([^=]+)(=(.*))?/.exec(p)
        var key = y(i[1]),
            value = i[3] || '';

        if (/\[/.test(key)) {
            key.match(/([^\[]+)|\[([^\]]+)\]/g).reduce(function (c, p, i, d) {
                return add(c, p.replace(/[\[\]]/g, ''), (d.length - 1 === i ? x(value) : {}));
            }, o);
        } else {
            add(c, key, x(value));
        }
        return o;
    }, o);

};

function encodeQueryString(query) {

    var str = [];
    for (var propName in query) {
        if (query.hasOwnProperty(propName)) {
            str.push(encodeURIComponent(propName) + '=' + encodeURIComponent(query[propName]));
        }
    }
    return str.join('&');

};

// --------------------------------------------------------------------------------------------

/*
 * source: https://github.com/axios/axios/blob/v1.x/lib/utils.js
 */

const ignoreDuplicateOf = utils.arrayToObjectSet([
    'age', 'authorization', 'content-length', 'content-type', 'etag',
    'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
    'last-modified', 'location', 'max-forwards', 'proxy-authorization',
    'referer', 'retry-after', 'user-agent'
]);

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */
function parseHeaders(rawHeaders) {

    const parsed = {};
    let key;
    let val;
    let i;

    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {

        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();

        if (!key || (parsed[key] && ignoreDuplicateOf[key])) {
            return;
        }

        if (key === 'set-cookie') {
            if (parsed[key]) {
                parsed[key].push(val);
            } else {
                parsed[key] = [val];
            }
        } else {
            parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
        }
    });

    return parsed;

};

function getCookie(name) {

    var key = name + "=",
        ca = document.cookie.split(';'),
        c = null;

    for (var i = 0; i < ca.length; i++) {
        c = ca[i];
        while (c.charAt(0) == ' ')
            c = c.substring(1);
        if (c.indexOf(key) == 0) {
            return c.substring(key.length, c.length);
        }
    }
    return null;
};

function setCookie(name, value, lifespan) {

    lifespan ||= 24 * 60 * 60; // one day

    var d = new Date();
    d.setTime(d.getTime() + (lifespan * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = name + "=" + value + "; " + expires;

};

export {
    parseQueryString,
    encodeQueryString,
    parseHeaders,
    getCookie,
    setCookie,
};
